import React from 'react'
import InteractiveAvatar from './interactive-avatar'
import Web from './web'
import Phone from './phone'
import { AgentProvider } from './agent.context'
import ChatBot from './web-chat'

const DemoComponents = {
  'Interactive Avatar': <InteractiveAvatar />,
  Web: (
    <AgentProvider>
      <Web />
    </AgentProvider>
  ),
  Phone: (
    <AgentProvider>
      <Phone />
    </AgentProvider>
  ),
  Chat: <ChatBot />,
}

export default function Demo() {
  const agent = JSON.parse(localStorage.getItem('agent'))

  return DemoComponents[agent.method]
}
